import { useState, useContext } from 'react';

import {
  Grid,
  Paper,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Button
} from '@material-ui/core';
import { format } from 'date-fns';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import { SessionContext } from '../../context/session.context';
import { createExpense } from '../../services/expenses.service';

export const ExpensesCreateComponent = () => {

  const { user } = useContext(SessionContext);

  const history = useHistory();

  const { enqueueSnackbar } = useSnackbar();

  const [expense, setExpense] = useState({
    product: '',
    quantity: 0,
    description: '',
    date: format(new Date(), 'yyyy-MM-dd'),
    worker: user.name,
    canceled: false
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setExpense({
      ...expense,
      [name]: value
    });
  }

  const save = async () => {
    if (isNaN(+expense.quantity) || +expense.quantity <= 0) {
      enqueueSnackbar('La cantidad debe ser mayor a 0', {
        variant: 'error',
        resumeHideDuration: 3000,
        anchorOrigin:
          { horizontal: 'right', vertical: 'bottom' },
      });
    } else {
      await createExpense(expense);
      enqueueSnackbar(`${expense.product} añadido`, {
        variant: 'success',
        resumeHideDuration: 3000,
        anchorOrigin:
          { horizontal: 'right', vertical: 'bottom' },
      });
      history.push('/expenses');
    }
  }

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} lg={8}>
        <Paper elevation={2} style={{ padding: '10px' }}>
          <Grid container justifyContent="center" spacing={1}>
            <Grid item xs={10}>
              <Typography variant="h4" align="center">Añadir gasto</Typography>
            </Grid>
            <Grid item xs={11} lg={8}>
              <TextField
                variant="outlined"
                fullWidth
                id="product"
                name="product"
                label="Producto"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={11} lg={4}>
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="quantity">Precio</InputLabel>
                <OutlinedInput
                  id="quantity"
                  name="quantity"
                  startAdornment={<InputAdornment position="start">$</InputAdornment>}
                  labelWidth={60}
                  onChange={handleChange}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                id="description"
                name="description"
                label="Descripción"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container justifyContent="flex-end" spacing={1}>
                <Grid item>
                  <Button variant="contained" onClick={() => history.goBack()}>Cancelar</Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={save}
                    disabled={!expense.product || !expense.quantity}
                  >
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}